import request from '@/utils/request'
import { parseStrEmpty } from '@/utils/ruoyi'
// 查询用户列表分页
export function pageUser(query) {
  return request({
    url: '/system/user/page',
    method: 'get',
    params: query,
  })
}
// 查询企业下的所有用户
export function employee(query) {
  return request({
    url: '/system/user/tenant/agent/employee',
    method: 'get',
    params: query,
  })
}
// 查询企业品牌logo
export function tenantPub(query) {
  return request({
    url: '/system/tenant/public',
    method: 'get',
    params: query,
  })
}
// 公告
export function noticePage(query) {
  return request({
    url: '/system/notice/page',
    method: 'get',
    params: query,
  })
}
// 首页大屏数据统计
export function largeScreen(query) {
  return request({
    url: '/fix/stat/large/screen',
    method: 'get',
    params: query,
  })
}
// 首页大屏数据统计区域
export function largeScreenRegion(query) {
  return request({
    url: '/fix/stat/large/screen/region',
    method: 'get',
    params: query,
  })
}
// 消息
export function noticeList(query) {
  return request({
    url: '/system/notice/list',
    method: 'get',
    params: query,
  })
}
// 查询消息列表
export function noticeWay (query) {
  return request({
    url: '/news/news/page',
    method: 'get',
    params: query,
  })
}
// 查询用户列表
export function listUser(query) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query,
  })
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: '/system/user/' + parseStrEmpty(userId),
    method: 'get',
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/system/user',
    method: 'post',
    data: data,
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/system/user',
    method: 'put',
    data: data,
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: '/system/user/' + userId,
    method: 'delete',
  })
}

// 用户密码重置
export function resetUserPwd(id, password) {
  const data = {
    id,
    password,
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data,
  })
}

// 用户状态修改
export function changeUserStatus(id, status) {
  const data = {
    id,
    status,
  }
  return request({
    url: '/system/user/changeStatus',
    method: 'put',
    data: data,
  })
}
// 首页数据统计
export function statHome(query) {
  return request({
    url: '/fix/stat/home1',
    method: 'get',
    params: query,
  })
}
// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get',
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data,
  })
}
// 检验手机号是否存在
export function checkPhone(data) {
  return request({
    url: '/system/user/check/phone',
    method: 'post',
    data: data,
  })
}
//  绑定用户
export function userBd(data) {
  return request({
    url: '/system/user/bd01',
    method: 'post',
    data: data,
  })
}
//  用户密码重置x新
export function updateUserPwdNew(data) {
  return request({
    url: '/update-password',
    method: 'post',
    data: data,
  })
}
// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword,
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data,
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/common/local/file/upload',
    method: 'post',
    data: data,
  })
}
// 获取签名
export function ossSignature(data) {
  return request({
    url: '/common/t/cos/signature',
    method: 'get',
    params: data,
  })
}
// 获取图片路径
export function ossSigkey(data) {
  return request({
    url: '/common/m/oss/key',
    method: 'get',
    params: data,
  })
}
// // 用户头像上传
// export function uploadCs(data) {
//   return request({
//     url: 'http://1.95.89.154:7078/hoy-01/%E5%9F%9F%E5%90%8D%E8%AF%81%E4%B9%A6.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=EJXJD3z3McjVps2j215D%2F20241118%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20241118T114717Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=7268aaeab1dd56305b715537ffa3c386c91f4d036ff42b92cd9f6c886305f3d4',
//     method: 'put',
//     data: data
//   })
// }
// 导入用户
export function importData(data) {
  return request({
    url: '/system/user/importData',
    method: 'post',
    data: data,
  })
}

// // 查询授权角色
// export function getAuthRole(userId) {
//   return request({
//     url: '/system/user/authRole/' + userId,
//     method: 'get'
//   })
// }
// 查询授权角色
export function getAuthRole(data) {
  return request({
    url: '/system/role/page',
    method: 'get',
    params: data,
  })
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: '/system/user/authRole',
    method: 'put',
    data: data,
  })
}

// 查询部门下拉树结构
export function deptTreeSelect() {
  return request({
    url: '/system/user/deptTree',
    method: 'get',
  })
}
